const UpsellingType = Object.freeze({
  GUIDE: 'GUIDE',
  CHECKLIST: 'CHECKLIST',
  CAMPAIGN: 'CAMPAIGN',
  QUIZZARD: 'QUIZZARD'
})

export default UpsellingType
